/**
 * Module definitions (Phase 6, BUILD_PLAN section 6 "modules"): small, bounded stat changes a
 * pilot equips in the hangar. The bounds live here so no data file can grant invulnerability,
 * cloaking or a runaway multiplier: scales stay within 0.8..1.25, the armour bonus within 0.1,
 * and there are no status flags at all. Modules in one `group` are mutually exclusive.
 */
import { z } from 'zod';
const id = z.string().regex(/^[a-z][a-z0-9-]*$/);
const scale = z.number().finite().min(0.8).max(1.25);
/** Capacity multipliers only ever add (Phase 8): a module cannot shrink a hull or a shield. */
const boost = z.number().finite().min(1).max(1.25);
export const MODULE_GROUPS = [
    'armour',
    'thermal',
    'mobility',
    'jets',
    'systems',
    'weapons',
];
export const ModuleGroupSchema = z.enum(MODULE_GROUPS);
/** The subset of the status-effect stat mods a module may carry, each bounded. */
export const ModuleModsSchema = z
    .object({
    speedScale: scale.optional(),
    turnScale: scale.optional(),
    fireRateScale: scale.optional(),
    heatScale: scale.optional(),
    dissipationScale: scale.optional(),
    spreadScale: scale.optional(),
    armorBonus: z.number().finite().min(0).max(0.1).optional(),
    cooldownScale: scale.optional(),
    jetThrustScale: scale.optional(),
    jetCostScale: scale.optional(),
    /** Hull and shield capacity (Phase 8): applied to the seat's definition, not per tick. */
    hpScale: boost.optional(),
    shieldScale: boost.optional(),
})
    .strict();
/** The mods that change a definition once per match rather than a tick's stat block. */
export const CAPACITY_MOD_KEYS = ['hpScale', 'shieldScale'];
export const ModuleDefinitionSchema = z
    .object({
    id,
    name: z.string().min(1).max(40),
    group: ModuleGroupSchema,
    /** One line for the hangar. */
    description: z.string().min(1).max(160),
    /** Credits; every module is bought (no free or level-gated modules in Phase 6). */
    price: z.number().int().positive(),
    mods: ModuleModsSchema,
})
    .strict();
//# sourceMappingURL=module-schema.js.map